// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__magnatHead_3443bf', '__magnatHead_Fallback_3443bf'"},"className":"__className_3443bf","variable":"__variable_3443bf"};